module.exports = __webpack_public_path__ + "static/media/top-wave.2f041052.svg";